import React, { Component } from 'react';
import BEMHelper from '@ynap/bem-helper';
import ViewportObserver from '@ynap/viewport-observer';
import PropTypes from 'prop-types';
import { Bling as GPT } from 'react-gpt';
import DEFAULT_SIZE_MAPPING from './sizeMapping';
const bem = new BEMHelper('Advertisement');
class Advertisement extends Component {
    constructor(props) {
        super(props);
        this.state = { modifiers: null };
    }

    render() {
        const { ynapadslot, path, className, sizeMapping = DEFAULT_SIZE_MAPPING, ...props } = this.props;
        const { modifiers } = this.state;

        const adUnitPath = ynapadslot?.adParameter || path;
        if (!adUnitPath) return null;
        const isProductReplacement = ynapadslot?.isProductReplacement;

        return (
            <ViewportObserver>
                {(intersected) =>
                    intersected && (
                        <div className={bem(null, modifiers, modifiers && className)}>
                            <GPT
                                adUnitPath={adUnitPath}
                                sizeMapping={sizeMapping}
                                renderWhenViewable={false}
                                onSlotOnload={() =>
                                    this.setState({ modifiers: isProductReplacement ? ['showContainerAd', 'showContent'] : ['showContainer', 'showContent'] })
                                }
                                onScriptLoaded={() => this.setState({ modifiers: 'showContainer' })}
                                {...props}
                            />
                        </div>
                    )
                }
            </ViewportObserver>
        );
    }
}

Advertisement.layoutVariant = ['isc-advertisment-block'];

Advertisement.propTypes = {
    ynapadslot: PropTypes.shape({
        adParameter: PropTypes.string,
        isProductReplacement: PropTypes.boolean,
    }),
    path: PropTypes.string,
    sizeMapping: PropTypes.array,
    className: PropTypes.string,
};

export default Advertisement;
export { DEFAULT_SIZE_MAPPING };
